<template>
    <MainMenu :menuOpen="menuOpen" />

    <div class="min-h-screen bg-gray-100">
        <div class="content w-full lg:w-5/6 min-h-screen flex flex-col pt-0">
            <TopBar/>
            <Header class="mb-8 lg:mb-16" :menuOpen="menuOpen" />

            <div class="px-4 mb-16 lg:px-8 xl:px-20">
                <slot name="header"/>
                <slot/>
                <MobileMenuButton @toggleMenu="toggleMenu" :menuOpen="menuOpen" />
            </div>
        </div>
        <Popup />
    </div>
</template>

<script>
import Popup from '@/Components/Popup';
import MainMenu from '@/Components/MainMenu';
import Header from '@/Components/Header';
import TopBar from '@/Components/TopBar';
import MobileMenuButton from '@/Components/MobileMenuButton';

export default {
    data: () => ({
        menuOpen: false,
    }),
    components: {Header, MainMenu, TopBar, MobileMenuButton, Popup},
    methods: {
        toggleMenu() {
            this.menuOpen = !this.menuOpen;
        }
    }
};
</script>
